import { createAction } from '@reduxjs/toolkit'

export const cacheCallBegan = createAction('cache/callBegan')
export const cacheHit = createAction('cache/hit')
export const cacheMiss = createAction('cache/miss')
